module.exports = __webpack_public_path__ + "static/img/img_6.91b25bbb.jpg";